import { render } from "./Benefit.vue?vue&type=template&id=087a8bd0"
import script from "./Benefit.vue?vue&type=script&lang=js"
export * from "./Benefit.vue?vue&type=script&lang=js"
script.render = render

export default script